import React, { useContext, useState } from 'react'
import { useLists } from '../hooks'
import { AuthContext } from '../Auth'
import NavBar from './NavBar'
import { Link } from 'react-router-dom'
import ListPreview from './ListPreview'
import { IconPlus } from './Icons'
import Loader from './Loader'

export default () => {
    const handleHomeClick = () => {
        localStorage.removeItem('displayedGroup')
    }    
    const { currentUser } = useContext(AuthContext)
    if (currentUser === null) return <div />
    const [listsRefresher, setListsRefresher] = useState(0)
    const { lists, loading } = useLists(currentUser.uid, listsRefresher)

    if (loading) {
        return (
            <div className="w-full h-screen flex flex-col justify-center items-center app-bg">
                <div className="flex flex-row w-full h-12 page-header items-center justify-center">
                    <span className="page-header-title">Mes listes</span>
                </div>
                <div className="h-full flex flex-col justify-center items-center">
                    <div className="empty-state">
                        <div className="empty-title">Chargement des données</div>
                    </div>
                    <Loader />
                </div>

                <div className={`w-full h-12 nav-wrap sticky bottom-0`}>
                    <NavBar activeMenu="list" onHomeClick={handleHomeClick} />
                </div>
            </div>
        )
    }

    if (lists.length === 0) {
        return (
            <div className="w-full h-screen flex flex-col justify-center items-center app-bg">
                <div className="flex flex-row w-full h-12 page-header items-center justify-center">
                    <span className="page-header-title">Mes listes</span>
                </div>
                <div className="h-full flex flex-col justify-center items-center">
                    <div className="empty-state">
                        <div className="empty-title">Créer des listes</div>
                        <div className="empty-text">Pour essayer, c’est par ici :</div>
                        <Link
                            className="empty-plus"
                            to="/createlist"
                            aria-label="Créer une liste"
                        >
                            <IconPlus />
                        </Link>
                    </div>
                </div>

                <div className={`w-full h-12 nav-wrap sticky bottom-0`}>
                    <NavBar activeMenu="list" onHomeClick={handleHomeClick} />
                </div>
            </div>
        )
    }

    return (
        <div className="h-screen w-full flex flex-col app-bg">
            <div className="flex flex-row w-full h-12 page-header items-center justify-center">
                <span className="page-header-title">Mes listes</span>
            </div>
            <div className="flex flex-col w-full mt-8 border-t-2">
                {lists.map(({ name, group, id, date, itemN }, index) => {
                    return (
                        <ListPreview
                            currentUserId={currentUser.uid}
                            key={id.concat(Math.random())}
                            id={id}
                            name={name}
                            classes={group}
                            itemsN={itemN}
                            date={date}
                            refresher={setListsRefresher}
                        />
                    )
                })}
            </div>
            <div className="h-screen" />
            <Link
                className="empty-plus lists-plus"
                to="/createlist"
                aria-label="Créer une liste"
            >
                <IconPlus />
            </Link>
            <div className={`w-full h-12 nav-wrap sticky bottom-0`}>
                <NavBar activeMenu="list" onHomeClick={handleHomeClick}/>
            </div>
        </div>
    )
}
